import React, { useState, useEffect } from 'react';
import BRTStopMarkers from './BRTStopMarkers';
import BUSStopMarkers from './BUSStopMarkers';
import LRTStopMarkers from './LRTStopMarkers';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import MRTStopMarkers from './MRTStopMarkers';

function FilteredStopMarkers({ stops = {}, userLocation, overlappingStops }) {
    const [openDialog, setOpenDialog] = useState(false);

    const noStopsNearby =
        !stops ||
        (!(stops.BRT?.length ?? 0) &&
            !(stops.LRT?.length ?? 0) &&
            !(stops.BUS?.length ?? 0));

    useEffect(() => {
        if (noStopsNearby && userLocation) {
            setOpenDialog(true);
        } else {
            setOpenDialog(false);
        }
    }, [noStopsNearby, userLocation]);

    return (
        <>
            {/* Dialog when no stops nearby */}
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                    <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                    No Stops Nearby
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary">
                        We couldn't find any stops near your current location within the selected distance and service filters.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} autoFocus variant="contained">
                        Got It
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Render Stop Markers if available */}
            <BRTStopMarkers stops={stops.BRT ?? []} userLocation={userLocation} />
            <LRTStopMarkers stops={stops.LRT ?? []} userLocation={userLocation} overlappingStops={overlappingStops} />
            <BUSStopMarkers stops={stops.BUS ?? []} userLocation={userLocation} />
            <MRTStopMarkers stops={stops.MRT ?? []} userLocation={userLocation} overlappingStops={overlappingStops} />
        </>
    );
}

export default FilteredStopMarkers;
